import React, { useState } from 'react';

import { LoadableLazy } from '@confluence/loadable';

const LivePagesChangeboardingModalManagerLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LivePagesChangeboardingModalManager" */
				'./LivePagesChangeboardingModalManager'
			)
		).LivePagesChangeboardingModalManager,
});

const LivePagesExpandedEapChangeboardingSpotlightsLoader = LoadableLazy({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-LivePagesExpandedEapChangeboardingSpotlights" */ './ExpandedEapChangeboarding/LivePagesExpandedEapChangeboardingSpotlights'
			)
		).LivePagesExpandedEapChangeboardingSpotlights;
	},
});

const LivePagesClosedBetaSpaceSettingsSpotlightLoader = LoadableLazy({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-LivePagesClosedBetaSpaceSettingsSpotlight" */ './ClosedBetaChangeboarding/LivePagesClosedBetaSpaceSettingsSpotlight'
			)
		).LivePagesClosedBetaSpaceSettingsSpotlight;
	},
});

type OriginType = 'view-page' | 'live-page';
export type LivePagesChangeboardingManagerProps = {
	origin: OriginType;
};
const originToComponentMap: Record<OriginType, React.ElementType> = {
	'view-page': LivePagesClosedBetaSpaceSettingsSpotlightLoader,
	'live-page': LivePagesExpandedEapChangeboardingSpotlightsLoader,
};

// Changeboarding starts at the modal step, and should not render anything during the stopped step
type ChangeboardingStateType = 'stopped' | 'modal' | 'walkthrough';

export const LivePagesChangeboardingManager = ({ origin }: LivePagesChangeboardingManagerProps) => {
	const SpotlightComponent = originToComponentMap[origin];
	/*
	 * The changeboarding modal and spotlights are independent messages, but
	 * if a user hasn't seen either, they should see the modal first & then the spotlights
	 */
	const [changeboardingState, setChangeboardingState] = useState<ChangeboardingStateType>('modal');

	return changeboardingState !== 'stopped' ? (
		<>
			{changeboardingState === 'modal' && (
				<LivePagesChangeboardingModalManagerLoader
					onClose={() => setChangeboardingState('walkthrough')}
				/>
			)}
			{changeboardingState === 'walkthrough' && (
				<SpotlightComponent onStop={() => setChangeboardingState('stopped')} />
			)}
		</>
	) : null;
};
